import { FilePickerViewType } from '../../types/FilePickerViewSwitcher';
import strings from 'owa-strings/owa-mail-strings';

export default function getAriaLabelForViewSwitcher(
    selectedView: FilePickerViewType,
    supportedViews: FilePickerViewType[]
): string {
    // We cycle between the supported views, and need to know the next view for the aria label
    const currentViewIndex = supportedViews.indexOf(selectedView);
    const nextViewIndex = currentViewIndex + 1 >= supportedViews.length ? 0 : currentViewIndex + 1;

    return viewTypeDisplayStrings[supportedViews[nextViewIndex]];
}

const viewTypeDisplayStrings: { [filePickerViewType: number]: string } = Object.freeze({
    [FilePickerViewType.List]: strings.ViewSwitcherListView_TitleText,
    [FilePickerViewType.Tile]: strings.ViewSwitcherTileView_TitleText,
});
